import React from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
  LinkedinIcon,
  LinkedinShareButton,
} from 'react-share';

import { socialShareIcons } from './share-icons.module.scss';

export default function ShareIcons({ title, blogPostUrl }) {
  return (
    <div className={socialShareIcons}>
      <FacebookShareButton title={title} url={blogPostUrl}>
        <FacebookIcon round={true} size={48} />
      </FacebookShareButton>
      <TwitterShareButton title={title} hashtags={['Codilime']} url={blogPostUrl}>
        <TwitterIcon round={true} size={48} />
      </TwitterShareButton>
      <LinkedinShareButton title={title} url={blogPostUrl}>
        <LinkedinIcon round={true} size={48} />
      </LinkedinShareButton>
    </div>
  );
}
